import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { SelectField } from '@module/mdrt-org/shared/components/select-field/select-field';
import { MAX_EMAIL_LENGTH } from '@module/mdrt-org/shared/utils/constants/input-constants';
import { MAX_AREA_CODE_LENGTH, MAX_PHONE_NUMBER_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { allowOnlyNumbersTransform } from '@module/mdrt-org/shared/utils/helpers/allow-only-numbers';
import { EMAIL_REGEXP } from '@module/mdrt-org/shared/utils/types/regexp';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { type SelectOption } from '@shared/utils/types/select-option';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type ContactInformationSectionProps = {
  cmsContent: {
    areaCode: string;
    contactInformationSectionTitle: string;
    email: string;
    invalidEmailValidationMessage: string;
    isoCode: string;
    phoneNumber: string;
    requiredLabel: string;
  };
  containerClass: string;
  phoneIsoCodeOptions: Array<SelectOption<string>>;
  setActiveField: (field: string) => void;
};
export const ContactInformationSection = t0 => {
  const $ = _c(45);
  const {
    cmsContent,
    containerClass,
    phoneIsoCodeOptions,
    setActiveField
  } = t0;
  const t1 = styles[`${containerClass}__contact-information-block`];
  let t2;
  if ($[0] !== cmsContent.contactInformationSectionTitle) {
    t2 = <h2 className={styles["section-title"]}>{cmsContent.contactInformationSectionTitle}</h2>;
    $[0] = cmsContent.contactInformationSectionTitle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = styles[`${containerClass}__contact-information-block-inputs`];
  let t4;
  if ($[2] !== setActiveField) {
    t4 = () => setActiveField("PhoneNumber");
    $[2] = setActiveField;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== cmsContent.requiredLabel) {
    t5 = {
      required: cmsContent.requiredLabel
    };
    $[4] = cmsContent.requiredLabel;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cmsContent.isoCode || $[7] !== phoneIsoCodeOptions || $[8] !== t4 || $[9] !== t5) {
    t6 = <SelectField isSearchable={true} label={cmsContent.isoCode} name="isoCode" onFocus={t4} options={phoneIsoCodeOptions} rules={t5} />;
    $[6] = cmsContent.isoCode;
    $[7] = phoneIsoCodeOptions;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== setActiveField) {
    t7 = <FormInput onFocus={() => setActiveField("PhoneNumber")} />;
    $[11] = setActiveField;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== cmsContent.areaCode || $[14] !== t7) {
    t8 = <FieldController label={cmsContent.areaCode} maxLength={MAX_AREA_CODE_LENGTH} name="phoneAreaCode" transform={allowOnlyNumbersTransform}>{t7}</FieldController>;
    $[13] = cmsContent.areaCode;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== cmsContent.requiredLabel) {
    t9 = {
      required: cmsContent.requiredLabel
    };
    $[16] = cmsContent.requiredLabel;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== setActiveField) {
    t10 = <FormInput onFocus={() => setActiveField("PhoneNumber")} />;
    $[18] = setActiveField;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== cmsContent.phoneNumber || $[21] !== t10 || $[22] !== t9) {
    t11 = <FieldController label={cmsContent.phoneNumber} maxLength={MAX_PHONE_NUMBER_LENGTH} name="phoneNumber" rules={t9}>{t10}</FieldController>;
    $[20] = cmsContent.phoneNumber;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== cmsContent.invalidEmailValidationMessage) {
    t12 = {
      message: cmsContent.invalidEmailValidationMessage,
      value: EMAIL_REGEXP
    };
    $[24] = cmsContent.invalidEmailValidationMessage;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== cmsContent.requiredLabel || $[27] !== t12) {
    t13 = {
      pattern: t12,
      required: cmsContent.requiredLabel
    };
    $[26] = cmsContent.requiredLabel;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== setActiveField) {
    t14 = <FormInput onFocus={() => setActiveField("Email")} type="email" />;
    $[29] = setActiveField;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== cmsContent.email || $[32] !== t13 || $[33] !== t14) {
    t15 = <FieldController label={cmsContent.email} maxLength={MAX_EMAIL_LENGTH} name="email" rules={t13}>{t14}</FieldController>;
    $[31] = cmsContent.email;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t15 || $[37] !== t3 || $[38] !== t6 || $[39] !== t8) {
    t16 = <div className={t3}>{t6}{t8}{t11}{t15}</div>;
    $[35] = t11;
    $[36] = t15;
    $[37] = t3;
    $[38] = t6;
    $[39] = t8;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t1 || $[42] !== t16 || $[43] !== t2) {
    t17 = <section className={t1}>{t2}{t16}</section>;
    $[41] = t1;
    $[42] = t16;
    $[43] = t2;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
};